<template>

  <nav class="navbar" tabindex="-1" :class="{ 'scrolled': !view.atTopOfPage }">

    <div class="nav-inner justify-between">

      <div class="flex-1 max-w-sm navbar-start">
        <div class="flex items-center justify-start">
          <NuxtLink to="/" class="p-3 logo-dark hidden">
            <img src="@/assets/img/supapm-logo-dark.svg" alt="Logo" width="80px" height="33px">
          </NuxtLink>
          <NuxtLink to="/" class="p-3 logo-light hidden">
            <img src="@/assets/img/supapm-logo.svg" alt="Logo" width="80px" height="33px">
          </NuxtLink>
        </div>
      </div>

      <!-- The DESKTOP part -->
      <div class="justify-end flex-auto font-light flex">

        <div class="flex items-center">

          <div v-if="!supabaseUser">
            <NuxtLink to="/login" class="btn btn-outline btn-sm">
              Join Waitlist
            </NuxtLink>
          </div>

          <div v-if="!!supabaseUser" class="dropdown dropdown-hover dropdown-end">
            <label tabindex="0" class="btn btn-ghost btn-circle">
              <img src="@/assets/icons/profile.svg" width="25" alt="Acount" class="icon">
            </label>


            <ul tabindex="0" class="p-2 dropdown-content z-50 menu bg-base-200 shadow rounded-box w-52">
              <li>
                <NuxtLink :to="`/profile/${supabaseUser.id}`" class="justify-between w-full">
                  Profile
                </NuxtLink>
              </li>

              <!-- <li>
                <NuxtLink to="/company" class="justify-between w-full">
                  Companies
                </NuxtLink>
              </li> -->

              <li class="mt-10"><a @click="signOut" class="w-full">Logout</a></li>
            </ul>
          </div>

        </div>

      </div>

    </div>

  </nav>


</template>

<style scoped>

[data-theme='dark'] #themeIcon #sunLogo {
  display: inline;
}

[data-theme='light'] #themeIcon #moonLogo {
  display: inline;
}

.navbar .navItem {
  font-weight:400;
  @apply text-base p-3;
}

.dropdown .btn:hover,
.dropdown .btn:active,
.dropdown .btn:focus {
  /* background: none; */
  --tw-bg-opacity: 0.1;
}

[data-theme='dark'] nav.scrolled {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

nav {
  @apply bg-base-100;
  position: relative;
  top:0;
  transition: box-shadow 0.1s ease-in-out;
}

nav.scrolled {
  @apply shadow-2xl;
}

.nav-inner  {
  margin: auto;
  width: 100%;
  max-width: 1600px;
}
    
</style>

<script setup>

const colorScheme = useColorScheme()
const supabaseUser = useSupabaseUser()
const supabaseUserData = useSupabaseUserData()
const view = ref({
  atTopOfPage: true
})

onMounted(() => {
  console.log("Topnav mounted")

  if(supabaseUserData.value) {
    console.log("supabaseUserData:", supabaseUserData.value)
    colorScheme.value = supabaseUserData.value.personal_settings.theme || 'myLight'
  }

})


watch(supabaseUserData, (newUserData) => {
  console.log("supabaseUserData changed:", newUserData)
  colorScheme.value = newUserData?.personal_settings?.theme || 'myLight'
})



</script>